import { newsLetterService } from '@/services/news_letter.service';
import { useQuery } from '@tanstack/react-query';


export const useGetAllNewsLetters = (pageNumber: number) => {
    const { data, isLoading, isError, error, refetch, isPending } = useQuery({
        queryKey: ['newsLetter', pageNumber],
        queryFn: () => newsLetterService.getAllNewsLetters(pageNumber),
    });
    return {
        newsLetters: data?.data ?? [],
        totalPages: data?.pageCount,
        isLoading,
        isError,
        error,
        refetch,
        isPending,
    };
};
